import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/contacts/api-integration/loading';
import { getContactQueryOptions } from '@/_pages/contacts/api-service';

export const Route = createFileRoute('/_private/contacts/_template/$id/api-integration')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'API Integrations',
    tabKey: 'contacts/api-integration',
  },
  pendingComponent: Loading,
});
